var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from "@reduxjs/toolkit";
import { globalEventsHandler } from "@jti/fe-common";
import { getUser, LoyaltyApi } from "@jti/rest-api";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { Status } from "../../types/LoyaltyCore.types";
export const fetchUserPoints = createAsyncThunk("loyaltyCore/fetchUserPoints", (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ useLocalCache, dispatchUpdateEvent, dispatchCodeRegistrationEvent }, { getState }) {
    const user = getUser();
    const loyaltyApi = LoyaltyApi.init();
    if ((user === null || user === void 0 ? void 0 : user.uuid) && (user === null || user === void 0 ? void 0 : user.ciam_token)) {
        try {
            const response = yield loyaltyApi.getPoints(user.uuid, user.ciam_token, useLocalCache);
            const { points, expire_at, points_to_expire } = response;
            if (dispatchUpdateEvent) {
                globalEventsHandler.updateLoyaltyPoints().register(points);
            }
            if (dispatchCodeRegistrationEvent) {
                dispatchTrackingEvent(TrackingEvents.TrackingCodeSubmitSuccess, { user_points_balance: points });
            }
            return { balance: points, expire_at, points_to_expire, status: Status.COMPLETED };
        }
        catch (error) {
            console.error(error);
            throw new Error("Error while fetching user points");
        }
    }
    const points = getState().loyaltyCore.points;
    return Object.assign(Object.assign({}, points), { status: Status.FAILED });
}));
//# sourceMappingURL=fetchUserPoints.js.map